import Box from '@/common/components/Box'
import GeneralPoliticsSection from './components/GeneralPoliticsSection';
import FinancialSection from './components/FinancialSection';
import { useParams } from 'react-router-dom';
import useEstablishmentCompany from '@/features/establishments/hooks/useEstablishmentCompany';
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import GeneralPoliticsSectionLoadingState from './components/GeneralPoliticsSectionLoadingState';
import FinancialSectionLoadingState from './components/FinancialSectionLoadingState';
import NotificationsSection from './components/NotificationsSection';

const EstablishmentPoliticsShow = () => {
  const { id } = useParams()

  const {
    data: establishmentCompany,
    error: establishmentCompanyError = {} as any,
    refetch: refetchEstablishmentCompany,
    isPending: isEstablishmentCompanyPending,
  } = useEstablishmentCompany(id);

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={establishmentCompanyError?.status}
      refetchFunction={refetchEstablishmentCompany}
    >
      <Box className='flex flex-col gap-6 overflow-y-auto h-[calc(100vh-192px)]'>
        <div className='flex flex-col gap-4'>
          {isEstablishmentCompanyPending ? (
            <GeneralPoliticsSectionLoadingState />
          ) : (
            <GeneralPoliticsSection establishmentCompany={establishmentCompany} />
          )}
        </div>

        <div className='flex flex-col gap-4'>
          {isEstablishmentCompanyPending ? (
            <FinancialSectionLoadingState />
          ) : (
            <FinancialSection establishmentCompany={establishmentCompany} />
          )}
        </div>

        <NotificationsSection establishmentCompany={establishmentCompany} />
      </Box>
    </ErrorMessageWrapper>

  )
}

export default EstablishmentPoliticsShow;
